export default "__VITE_ASSET__DDRG3ApB__"